import styled, { css } from 'styled-components';
import { StepIndicatorOwnerState } from './StepIndicator.props';

export const STEP_INDICATOR_SIZE = 28;

const StepIndicatorRoot = styled.div<StepIndicatorOwnerState>`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  width: ${STEP_INDICATOR_SIZE}px;
  height: ${STEP_INDICATOR_SIZE}px;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  flex-shrink: 0;
  text-decoration: none;
  ${({ theme, ownerState }) => {
		const { primary, neutral } = theme.stepper.stepIndicator;
		const state = ownerState.active || ownerState.completed ? primary : neutral;

		return css`
      background-color: ${state.background};
      color: ${state.color};
    `;
	}}
`;

export { StepIndicatorRoot };

